<template>
<div>
  <template v-if="getRegisterAsInvitedFeedback.state === 'init'">
    <v-toolbar>
      <v-toolbar-title>
        {{$t('Register.RegisterInvitedUser.Title')}}
      </v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-alert type="info">
        {{$t('Register.RegisterInvitedUser.Info')}}
      </v-alert>
      <v-form v-model="valid">
        <v-text-field v-model="credentials.email" :label="$t('User.Email')" type="text" :rules="[rules.required, rules.email]"></v-text-field>
        <!-- <v-text-field v-model="credentials.password" label="Password" type="password" :rules="[rules.required, rules.min8, rules.hasNumber]"></v-text-field>
        <v-text-field v-model="passwordConfirmation" label="Password confirmation" type="password" :rules="[rules.required, passwordMatch]"></v-text-field> -->
        <v-text-field v-model="credentials.phone_number" :label="$t('User.PhoneNumber')" type="text" :rules="[rules.required]"></v-text-field>
        <v-text-field v-model="credentials.first_name" :label="$t('User.FirstName')" type="text" :rules="[rules.required]"></v-text-field>
        <v-text-field v-model="credentials.last_name" :label="$t('User.LastName')" type="text" :rules="[rules.required]"></v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-layout column>
        <div>{{error_message}}</div>
      </v-layout>
      <v-btn @click="close()">{{$t('Buttons.Cancel')}}</v-btn>
      <v-btn @click="checkRegistration()">{{$t('Register.RegisterInvitedUser.Button')}}</v-btn>
    </v-card-actions>
  </template>

  <template v-if="getRegisterAsInvitedFeedback.state === 'success'">
    <v-toolbar dark>
      <v-toolbar-title>
        {{$t('Register.RegisterInvitedUser.SuccessMsg.Title')}}
      </v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      {{$t('Register.RegisterInvitedUser.SuccessMsg.Msg[0]')}} {{ getRegisterAsInvitedFeedback.payload.first_name }}!
      <br> <br>
      {{$t('Register.RegisterInvitedUser.SuccessMsg.Msg[1]')}}
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="close()">{{$t('Buttons.Close')}}</v-btn>
    </v-card-actions>
  </template>

  <template v-if="getRegisterAsInvitedFeedback.state === 'error'">
    <v-toolbar dark>
      <v-toolbar-title>
        {{$t('Register.RegisterInvitedUser.FailureMsg.Title')}}
      </v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      {{$t('Register.RegisterInvitedUser.FailureMsg.Msg')}} <br>
      <br>
      <v-alert type="error">
        {{ getRegisterAsInvitedFeedback.payload }}
      </v-alert>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="close()">{{$t('Buttons.Close')}}</v-btn>
    </v-card-actions>
  </template>
</div>
</template>

<script>
import validators from '../../helpers/validators'
import {
  mapActions,
  mapGetters
} from 'vuex';
export default {

  data: () => ({
    credentials: {
      first_name: '',
      last_name: '',
      phone_number: '',
      email: '',
      password: '',
    },
    passwordConfirmation: '',
    error_message: '',
    rules: {},
    valid: false,
  }),
  computed: {
    ...mapGetters('View', [
      'getRegisterAsInvitedFeedback'
    ])
  },
  methods: {
    checkRegistration() {
      this.error_message = '';
      if (this.valid) {
        this.registerAsInvitedUser(this.credentials)
      } else {
        for (var credential in this.credentials) {
          if (!this.credentials[credential]) {
            this.credentials[credential] = null;
          }
        }
        this.error_message = 'Please check your credentials.'
      }
    },
    // passwordMatch(passwordConfirmation) {
    //   if (passwordConfirmation === this.credentials.password) {
    //     return true;
    //   } else {
    //     return 'password and password confirmation must be identical.';
    //   }
    // },
    close(){
      var self = this
      setTimeout(function() {
        self.$router.push({
          name: 'Home'
        })
      }, 150);
    },
    ...mapActions('User', [
      'registerAsInvitedUser'
    ])
  },
  created() {
    this.rules = validators;
  }
}
</script>
